// Produktová stránka — presmerovanie na sibling produkt
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.color-siblings__item');
  if (!btn) return;

  const url = btn.dataset.url;
  if (url) {
    window.location.href = url;
  }
});

// Kolekcia — zmena obrázku a názvu na karte
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.color-siblings-card__item');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const card = btn.closest('.product-card');
  if (!card) return;

  const mainImage = card.querySelector('.product-card__image--main img');
  const secondImage = card.querySelector('.product-card__image--second img');

  if (mainImage && btn.dataset.image) {
    mainImage.src = btn.dataset.image;
    mainImage.srcset = btn.dataset.image;
  }
  if (secondImage && btn.dataset.image) {
    secondImage.src = btn.dataset.image;
    secondImage.srcset = btn.dataset.image;
  }

  const url = btn.dataset.url;
  if (url) {
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.href = url;
    });
  }

  const title = btn.dataset.title;
  if (title) {
    const titleEl = card.querySelector('.product-card__title a');
    if (titleEl) titleEl.textContent = title;
  }

  btn.closest('.color-siblings-card__list')
    .querySelectorAll('.color-siblings-card__item')
    .forEach(function (b) {
      b.classList.remove('color-siblings-card__item--active');
    });
  btn.classList.add('color-siblings-card__item--active');
});